export enum FORMULARY_PRICE_STATE {
  CATEGORY = 'CATEGORY',
  CUSTOM = 'CUSTOM',
}
